import { createDownloadableLink } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  uploadHSAppointments:
    (data, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.post(
        `pax-screenings/import`,
        data,
        '',
        undefined,
        true,
        true
      );
      if (status === 200) {
        customToast('success', 'Upload success');
        callback && callback();
        createDownloadableLink(result, `HS-Appointment`);
      }
    },
};

const importHSAppointmentDispatcher = synthesize(
  'importHSAppointment',
  mapDispatchToAC
);

export default importHSAppointmentDispatcher;
